import { render, staticRenderFns } from "./VersionsLayoutsModal.vue?vue&type=template&id=95631c10&scoped=true"
import script from "./VersionsLayoutsModal.vue?vue&type=script&lang=js"
export * from "./VersionsLayoutsModal.vue?vue&type=script&lang=js"
import style0 from "./VersionsLayoutsModal.vue?vue&type=style&index=0&id=95631c10&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95631c10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95631c10')) {
      api.createRecord('95631c10', component.options)
    } else {
      api.reload('95631c10', component.options)
    }
    module.hot.accept("./VersionsLayoutsModal.vue?vue&type=template&id=95631c10&scoped=true", function () {
      api.rerender('95631c10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/display-builder/VersionsLayoutsModal.vue"
export default component.exports